import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  InvoiceStatistic2Request,
  InvoiceStatisticData,
  InvoiceStatisticGroupData,
  InvoiceStatisticRequest
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/invoice-statistic`;

export const getInvoiceStatistic = (
    invoiceStatisticRequest: InvoiceStatisticRequest,
    source: CancelTokenSource): Promise<InvoiceStatisticData> => {
  return axios
      .post(apiUri, invoiceStatisticRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const exportInvoiceStatistic = (
    invoiceStatisticRequest: InvoiceStatisticRequest,
    source: CancelTokenSource) => {

  return axios
      .post(`${apiUri}/export`, invoiceStatisticRequest,
          {responseType: 'blob', cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], {type: type});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "response.csv";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
};

export const getInvoiceStatisticOnlyByTreatmentDate = (
    invoiceStatisticRequest: InvoiceStatistic2Request,
    source: CancelTokenSource): Promise<InvoiceStatisticGroupData> => {

  return axios
      .post(`${apiUri}/onlyByTreatmentDate`, invoiceStatisticRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const exportInvoiceStatistic2 = (
    invoiceStatisticRequest: InvoiceStatistic2Request,
    source: CancelTokenSource) => {

  return axios
      .post(`${apiUri}/byTreatmentDate/export`, invoiceStatisticRequest,
          {responseType: 'blob', cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], {type: type});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "response.xlsx";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
};

export const detailedExportInvoiceStatistic2 = (
    invoiceStatisticRequest: InvoiceStatistic2Request,
    source: CancelTokenSource) => {

  return axios
      .post(`${apiUri}/byTreatmentDate/detailed-export`,
          invoiceStatisticRequest,
          {responseType: 'blob', cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], {type: type});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "detailed-response.xlsx";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
};
